
import { computed, defineComponent, PropType } from 'vue'

import Waypoint from './Waypoint.vue'
import FtlAdditionalService from '@/modules/FTLModule/components/FtlAdditionalService/index.vue'

import { FTLBidWaypointT } from '@/core/types/ftl_bids.types'

export default defineComponent({
    components: {
        Waypoint,
        FtlAdditionalService
    },
    props: {
        waypoints: {
            type: Array as PropType<FTLBidWaypointT[]>,
            default: () => []
        },
        bidId: {
            type: Number,
            required: true,
        }
    },
    setup(props) {
        const sender = computed(() => {
            if (props.waypoints.length) {
                const sender = props.waypoints.find((waypoint) => waypoint.number === 0)
                return sender
            }

            return null
        })

        const filteredWaypoints = computed(() => {
            return props.waypoints.filter((waypoint) => waypoint.number !== 0)
        })

        return {
            sender,
            filteredWaypoints
        }
    }
})
